module.exports = __webpack_public_path__ + "img/4_131.5835fce3.png";